export default __webpack_public_path__ + "static/media/hindi_agri_m.e6f7aa8d.wav";